import { ConstantsUtil } from '@web3modal/scaffold-utils';
import { AppKit } from '../src/client.js';
export * from '@web3modal/scaffold-ui';
export { CoreHelperUtil } from '@web3modal/core';
export function createWeb3Modal(options) {
    return new AppKit({
        ...options,
        sdkType: 'w3m',
        sdkVersion: `html-multichain-${ConstantsUtil.VERSION}`
    });
}
export { AppKit };
//# sourceMappingURL=index.js.map